import React from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'

import makeData from './makeData'
import {FormattedMessage} from "react-intl";

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

function Table({ columns, data ,approveUser,username, selectItem}) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })
  // data[i].id
  // Render the UI for your table
  return (
    <div className="tablewrapper">
      <table {...getTableProps()} >
      <thead>
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()} >
          <th>Select</th>
          {headerGroup.headers.map(column => (
            <th {...column.getHeaderProps()} style={{textAlign: 'center'}}>{column.render('Header')}</th>
          ))}
        </tr>
      ))}
      </thead>
      <tbody {...getTableBodyProps()}>
      {rows.map((row, i) => {
        prepareRow(row)
        return (
          <tr {...row.getRowProps()}>
            <td>
              <input type="radio" name="radio1" value={data[i]} onChange={()=>{selectItem(data[i]);}}
              />
            </td>
            {row.cells.map(cell => {
              if(cell.value === "null"){
                return <td {...cell.getCellProps()}></td>
              }
              // else if(cell.value === "PENDING_APPROVAL"){
              //   return <td {...cell.getCellProps()}>
              //     <button
              //       className="button"
              //       style={{ marginRight: '40px' }}
              //       type="button"
              //       // onClick={() => this.props.clickBackHandler()}
              //     >
              //      APPROVE
              //     </button>
              //   </td>
              // }
              else{
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              }
            })}
          </tr>
          )
      })}
      </tbody>
    </table>
    </div>
  )
}

function App(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Organization Name',
        accessor: 'companyName', // accessor is the "key" in the data
      },
      {
        Header: 'Admin First Name',
        accessor: 'contactFirstName',
      },
      {
        Header: 'Admin Last Name',
        accessor: 'contactLastName', // accessor is the "key" in the data
      },
      {
        Header: 'Email',
        accessor: 'contactEmail', // accessor is the "key" in the data
      },
      {
        Header: 'Status',
        accessor: 'status', // accessor is the "key" in the data
      }
    ],
    []
  );

  // const data2 = React.useMemo(() => makeData(20), [])

  return (
    <Styles>
      <Table columns={columns} data={props.data} selectItem={props.selectItem} />
    </Styles>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/views/Snowflake/table.js